import { DashboardView, SigmaInfo, SigmaAuthenticationStatus, SigmaAuthenticationStatusType } from './types.ts';
import { minBy } from 'lodash';

export const createSigmaInfo = (authenticationStatus: SigmaAuthenticationStatusType, dashboards: DashboardView[] = []): SigmaInfo => ({
  authenticationStatus,
  dashboards: dashboards,
  dashboardsNo: (dashboards || []).length,
  defaultDashboardId: minBy(dashboards || [], d => d.order)?.id ?? null
});

export const SIGMA_INFO_NOT_AUTHENTICATED: SigmaInfo = createSigmaInfo(SigmaAuthenticationStatus.NOT_AUTHENTICATED);
export const SIGMA_INFO_AUTHENTICATING: SigmaInfo = createSigmaInfo(SigmaAuthenticationStatus.AUTHENTICATING);
export const SIGMA_INFO_AUTHENTICATION_FAILED: SigmaInfo = createSigmaInfo(SigmaAuthenticationStatus.AUTHENTICATION_FAILED);
export const RELOAD_SIGMA_INFO_MAX_RETRIES = 3;
